module.exports = __webpack_public_path__ + "img/health-dashboard.ca140228.jpg";